<p-dialog [(visible)]="visible" header="Confirmar Exclusão" [modal]="true" [style]="{width: '90vw', maxWidth: '400px'}"
  (onHide)="close()" styleClass="delete-dialog">

  <div class="delete-content">
    <i class="pi pi-exclamation-triangle warning-icon"></i>
    <p>Tem certeza que deseja excluir este veículo?</p>

    <div class="delete-vehicle-info" *ngIf="vehicle">
      <i [class]="icon"></i>
      <div>
        <strong>{{ vehicle.marca }} {{ vehicle.modelo }}</strong>
        <p>{{ vehicle.ano }} - {{ vehicle.versao }}</p>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button class="dialog-btn btn-cancel" (click)="close()">Cancelar</button>
      <button class="dialog-btn btn-delete-confirm" (click)="confirm()">
        <i class="pi pi-trash"></i> Excluir
      </button>
    </div>
  </ng-template>
</p-dialog>